export default class Permission {
	constructor({added_on, description, id, name, update_on}) {
		this.added_on = added_on || "";
		this.description = description || "";
		this.id = id || 0;
		this.name = name || "";
		this.update_on = update_on || "";
	}
}
